import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Link } from "gatsby"


class G30g extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-color: #fff;
            padding: 80px 0;            
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #1a1a1a;
            padding-bottom: 30px;
            text-align: center;
        `

        const AboutContainer = styled(Container)`
            padding: 50px 0;            
            text-align: center;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
        `

        const Heading2 = styled.h2`
            font-size: 60px;
            font-family: "Montserrat", sans-serif;
            font-weight: bold;
            color: #000;
            line-height: 70px;
            text-align: center;
            padding-bottom: 80px;
            @media (max-width: 767px) {
                font-size: 40px;
                line-height: 50px;                
            }        
        `
        const TextaSpan = styled(Link)`        
            color: #78c91c;            
            transition: .5s;
            font-weight: 700;
            text-align: center;            
            &:hover {
                color: #000;
                text-decoration: none;
            }
            @media (max-width: 767px) {
                font-size: 40px;
                line-height: 50px;                
            } 
        `
        const Heading3 = styled.h3`
            font-size: 50px;            
            line-height: 60px;
        `    

        return (
            <Section>
                <AboutContainer>
                    <Row>
                        <Col md={12}>
                            <Heading2>Asesoría GRATIS en Ciberseguridad</Heading2>
                            <Text>
                                ¡Obtén una Asesoría Gratis! Descubre cómo podemos ayudarte a alcanzar tus objetivos y proteger tu información.
                            </Text>
                            <Heading3>
                                <TextaSpan to="/servicios-ciberseguridad-colombia/">Ciberseguridad en Colombia</TextaSpan>
                            </Heading3>
                        </Col>
                    </Row>
                </AboutContainer>
            </Section>

        )
    }
}

export default G30g